// Canwood Botanical — condense the header once the page is scrolled.
// Single source of truth: one IntersectionObserver sentinel pinned to the top
// of the document (its position never depends on the header's own height, so
// resizing the header can't feed back into the trigger). A short flip-lock
// prevents any chatter at the threshold. Toggles `cb-scrolled`; sizing is CSS.

(() => {
  const ENTER_AT = 90; // px scrolled before condensing
  const LOCK_MS = 300; // ignore further flips briefly after one
  let state = false;
  let lockedUntil = 0;
  let sentinel = null;

  const now = () => (window.performance ? performance.now() : 0);

  const set = (scrolled) => {
    if (scrolled === state) return;
    const t = now();
    if (t < lockedUntil) return;
    state = scrolled;
    lockedUntil = t + LOCK_MS;
    document
      .querySelectorAll('.header-section')
      .forEach((h) => h.classList.toggle('cb-scrolled', scrolled));
  };

  const init = () => {
    if (!document.body) return;

    sentinel = document.createElement('div');
    sentinel.setAttribute('data-cb-header-sentinel', '');
    Object.assign(sentinel.style, {
      position: 'absolute',
      top: '0',
      left: '0',
      width: '1px',
      height: ENTER_AT + 'px',
      pointerEvents: 'none',
      opacity: '0',
      zIndex: '-1',
    });
    document.body.prepend(sentinel);

    const io = new IntersectionObserver(
      (entries) => set(!entries[0].isIntersecting),
      { threshold: 0 }
    );
    io.observe(sentinel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
